<template>
  <HomePage/>
  <Footer />
</template>

<script>
import HomePage from './pages/HomePage.vue'
import Footer from "./components/Footer";

export default {
  name: 'App',
  components: {
    HomePage,
    Footer,
  }
}
</script>
